import React, {useState, useRef} from 'react'
import PPAListComponent from '../../components/Ppa/PpaList';
import SubHeader from '../../components/Subheader/Subheader';
import { useSelector } from 'react-redux';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';


export default function Ppa() {
    const { financialYears } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dateColumn, setDateColumn] = useState('approval_date');
    const [searchStr, setToSearchStr] = useState('');

    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setDateColumn(dateColumn);
        setToSearchStr(searchStr);
    };
    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }
    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>PPA</h4>
                    <CustomBreadcrumbs linksArray={[]} title="PPA"/>
                </div>
                <div className="col-md-6">
                    
                </div>
            </div>
            <div className='scheme p-2'>
                <PPAListComponent fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr}/>
            </div>
        </div>
    )
}